import { CalendarDisplaySettings } from '@pages/Calendar/ui/CalendarDisplaySettings';

import { useIndividualCalendarHeaderSettings } from '../hooks';

import '../styles/IndividualCalendarHeaderSettings.scss';

export const IndividualCalendarHeaderSettings = () => {
  const {
    intervalHeightSize,
    intervalHeightSizeOptions,
    gridStepMinutes,
    gridStepMinuteOptions,
    timeFormat,
    timeFormatOptions,
    isTimeFormatLoading,
    changeTimeFormatHandler,
    preferredMaxColumns,
    preferredMaxColumnOptions,
    gridStepMinutesChangeHandler,
    intervalHeightSizeChangeHandler,
    preferredMaxColumnsChangeHandler,
    previewFields,
    previewFieldsChangeHandler,
  } = useIndividualCalendarHeaderSettings();

  return (
    <div className="IndividualCalendarHeaderSettings">
      <CalendarDisplaySettings
        tooltipTitle="Настройки журнала записей"
        testId="individual-calendar-header-settings"
        intervalHeightSize={intervalHeightSize}
        intervalHeightSizeOptions={intervalHeightSizeOptions}
        gridStepMinutes={gridStepMinutes}
        gridStepMinuteOptions={gridStepMinuteOptions}
        timeFormat={timeFormat}
        timeFormatOptions={timeFormatOptions}
        isTimeFormatLoading={isTimeFormatLoading}
        onTimeFormatChange={changeTimeFormatHandler}
        preferredMaxColumns={preferredMaxColumns}
        preferredMaxColumnOptions={preferredMaxColumnOptions}
        onIntervalHeightSizeChange={intervalHeightSizeChangeHandler}
        onGridStepMinutesChange={gridStepMinutesChangeHandler}
        onPreferredMaxColumnsChange={preferredMaxColumnsChangeHandler}
        previewFields={previewFields}
        onPreviewFieldsChange={previewFieldsChangeHandler}
      />
    </div>
  );
};
